import * as actionTypes from "./actionTypes";

const initialState = {
  rows: [],
  dateFormat: "yyyy/mm/dd",
  isLoading: false,
  dataTypes: [],
  roleTypes: [],
  activeTypes: [],
  listTypes: [],
  paramTypes: [],
  requiredTypes: [],
  isTestingQuery: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_STATE:
      return initialState;

    case actionTypes.GET_ROWS:
      return { ...state, isLoading: true };
    case actionTypes.GET_ROWS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dataTypes: action.payload.dataTypes,
        roleTypes: action.payload.roleTypes,
        activeTypes: action.payload.activeTypes,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.GET_ROWS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dataTypes: action.payload.dataTypes,
        roleTypes: action.payload.roleTypes,
        activeTypes: action.payload.activeTypes,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.CREATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dataTypes: action.payload.dataTypes,
        roleTypes: action.payload.roleTypes,
        activeTypes: action.payload.activeTypes,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.MODIFY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dataTypes: action.payload.dataTypes,
        roleTypes: action.payload.roleTypes,
        activeTypes: action.payload.activeTypes,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.DELETE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DUPLICATE:
      return { ...state, isLoading: true };
    case actionTypes.DUPLICATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dataTypes: action.payload.dataTypes,
        roleTypes: action.payload.roleTypes,
        activeTypes: action.payload.activeTypes,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.DUPLICATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.EXPORT:
      return { ...state, isLoading: true };
    case actionTypes.EXPORT_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.EXPORT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.IMPORT:
      return { ...state, isLoading: true };
    case actionTypes.IMPORT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dataTypes: action.payload.dataTypes,
        roleTypes: action.payload.roleTypes,
        activeTypes: action.payload.activeTypes,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.IMPORT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GENERATE:
      return { ...state, isLoading: true };
    case actionTypes.GENERATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        listTypes: action.payload.listTypes,
        paramTypes: action.payload.paramTypes,
        requiredTypes: action.payload.requiredTypes,
      };
    case actionTypes.GENERATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.IMPLEMENT:
      return { ...state, isLoading: true };
    case actionTypes.IMPLEMENT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dataTypes: action.payload.dataTypes,
        roleTypes: action.payload.roleTypes,
        activeTypes: action.payload.activeTypes,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.IMPLEMENT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.TEST_QUERY:
      return { ...state, isTestingQuery: true };
    case actionTypes.TEST_QUERY_FULFILLED:
    case actionTypes.TEST_QUERY_REJECTED:
      return { ...state, isTestingQuery: false };

    default:
      return state;
  }
}
